import image from '../../assets/img/comment_pinned.svg';

interface PinnedIconProps {
    alt?: string;
    className?: string | null;
}

function PinnedIcon({ alt, className }: PinnedIconProps) {
    return <img src={image} className={className} alt={alt} />;
}

export default PinnedIcon;
